import { GameTypePlugin, GameRenderer, GameConfigurator, GameRendererCapabilities } from '../../interfaces/game-type-plugin.interface';
import { WheelRenderer } from './wheel-renderer';
import { WheelConfigurator } from './wheel-configurator';

/**
 * Wheel game type plugin.
 * Implements the GameTypePlugin interface for spin wheel games.
 */
export class WheelPlugin implements GameTypePlugin {
  readonly id = 'wheel';
  readonly name = 'Spin Wheel';
  readonly description = 'A spinning wheel game with customizable prizes and appearance';
  readonly version = '1.0.0';

  readonly capabilities: GameRendererCapabilities = {
    mode: 'hybrid',              // Uses both HTML (spin-wheel.js) and 3D (cylinder, arrow)
    requires3DScene: true,       // Needs 3D cylinder and arrow
    requiresHTMLContainer: true, // Needs HTML for the wheel face
    supportsAR: true,            // Fully supports AR mode
    supportsVR: false            // VR not yet supported
  };

  createRenderer(): GameRenderer {
    return new WheelRenderer();
  }

  createConfigurator(): GameConfigurator {
    return new WheelConfigurator();
  }
}
